import Calendar from "../payment/calendar";
import Notify from "./../notify";
import Litepicker from "./../litepicker";


export default class CalendarPayment extends Calendar {


    constructor(id, mounth = false, year = false) {

        super(id, mounth, year, false);
        this.selectedYear = null;
        this.selectedMounth = null;
        this.selectedDay = null;
        this.globalDateCreateStart = new Date();
        this.nextYear;
        this.selectedRangeDatesIsUSe = false;
        this.startPicker = null;
        this.endPicker = null;
        this.fullDates = {
            dates: [],
            selectedDates: [],
        };
    }



    getMinStaticDateForOrder() {
        return {
            mounth: new Date().getMonth() + 1,
            year: new Date().getFullYear()
        }
    }
    getDatesForOrder() {
        return [];
    }

    createMonth() {
        let inst = this;
        let mounthContainer = document.createElement("div");
        mounthContainer.classList.add(
            "sect",
            "grid-x",
            "grid-padding-x",
            "align-justify",
            "align-middle"
        );
        if (
            this.staticMinDateMounth < this.currentMonth ||
            this.staticMinDateYear < this.currentYear
        ) {
            let leftArrow = document.createElement("div");
            leftArrow.classList.add("cell", "shrink");

            let linkLeftArrow = document.createElement("a");
            linkLeftArrow.classList.add("calendar-month-link");
            linkLeftArrow.innerHTML = "<i class='fas fa-chevron-left'>";
            leftArrow.appendChild(linkLeftArrow);
            mounthContainer.appendChild(leftArrow);

            linkLeftArrow.addEventListener("click", function(e) {
                e.preventDefault();

                inst.currentMonth = inst.currentMonth - 1;

                if (inst.currentMonth < 0) {
                    inst.currentMonth = 11;
                    inst.currentYear = parseInt(inst.currentYear) - 1;
                }

                inst.init(true);
            });

        }

        let rightArrow = document.createElement("div");
        rightArrow.classList.add("cell", "shrink");

        let linkRightArrow = document.createElement("a");
        linkRightArrow.classList.add("calendar-month-link");
        linkRightArrow.innerHTML = "<i class='fas fa-chevron-right'>";
        rightArrow.appendChild(linkRightArrow);

        linkRightArrow.addEventListener("click", function(e) {
            e.preventDefault();

            inst.currentMonth = inst.currentMonth + 1;


            if (inst.currentMonth > 11) {
                inst.currentMonth = 0;
                inst.currentYear = parseInt(inst.currentYear) + 1;
            }

            inst.init(true);
        });

        let mounthName = document.createElement("div");
        mounthName.classList.add("cell", "auto", "calendar-month-title");

        mounthName.innerHTML = this.monthes[this.currentMonth] + " " + this.currentYear;

        mounthContainer.appendChild(mounthName);
        mounthContainer.appendChild(rightArrow);

        return mounthContainer;
    }

    setSelectedDate(y, m, d) {
        this.selectedDay = d;
        this.selectedMounth = m;
        this.selectedYear = y;
    }



    createDays() {

        let instance = this;
        instance.firstDay = new Date(this.currentYear, this.currentMonth, 1);
        instance.firstDayWeek = instance.firstDay.getDay();
        this.next = this.firstDay.getMonth();
        this.nextYear = this.firstDay.getFullYear();
        instance.t = instance.firstDayWeek - 1;
        if (instance.t < 0) {
            instance.t = 6;
        }
        let daysCalendar = document.createElement("div");

        daysCalendar.classList.add("calendar-dates");
        let a = 0;

        while (this.firstDay.getMonth() == this.currentMonth) {
            let firstDay = this.firstDay;
            let i = 0;

            let row = document.createElement("div");
            row.classList.add("grid-x", "small-up-7", "text-center");


            while (i < 7) {
                let col;
                if (a == 0) {
                    if (i < this.t) {
                        col = document.createElement("div");
                        col.classList.add("cell", "calendar-date-none");
                        col.innerHTML = "";
                        col.setAttribute("data-day", this.firstDay.getDate());
                    } else {
                        let colClass = "calendar-date-disabled--hover";

                        col = document.createElement("div");
                        if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                            colClass = "calendar-date-none";
                        } else {
                            col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());


                        }
                        col.classList.add("cell", colClass);
                        col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                        col.setAttribute("data-day", this.firstDay.getDate());

                        this.firstDay.setDate(this.firstDay.getDate() + 1);
                    }
                } else {

                    if (this.next > this.currentMonth || this.nextYear > this.currentYear) {
                        break;
                    }
                    let colClass = "calendar-date-disabled--hover";
                    col = document.createElement("div");
                    if (new Date(this.firstDay.getFullYear(), this.firstDay.getMonth(), this.firstDay.getDate()) < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                        colClass = "calendar-date-none";

                    } else {

                        col.setAttribute("data-key", new Date(firstDay.getFullYear(), firstDay.getMonth(), this.firstDay.getDate()).getTime());


                    }
                    col.classList.add("cell", colClass);

                    col.innerHTML = "<span class='day'>" + this.firstDay.getDate() + "</span>";
                    col.setAttribute("data-day", this.firstDay.getDate());
                    this.firstDay.setDate(this.firstDay.getDate() + 1);
                    this.next = this.firstDay.getMonth();
                    this.nextYear = this.firstDay.getFullYear();


                }
                row.appendChild(col);
                i++;

            }

            daysCalendar.appendChild(row);
            a++;

        }

        return daysCalendar;
    }

    expandRange(firstDate, lastDate) {
        let range = [];
        let date = null;

        if (firstDate && lastDate) {
            range.push(firstDate);
            date = null;
            if (firstDate == lastDate) {
                return range;
            }


            while (firstDate != lastDate || firstDate < lastDate) {
                date = new Date(new Date().setTime(firstDate));
                firstDate = new Date(date.setDate(date.getDate() + 1)).getTime();
                range.push(firstDate);

            }
        }


        return range;
    }


    startFill(range) {

        if (Array.isArray(range)) {

            if (range.length > 0) {

                for (let dat in range) {
                    $("[data-key='" + range[dat] + "']").addClass("active");
                }
            }
        }
    }




    endFill() {

        $(document).find(".calendar-date-disabled--hover.active").each(function() {
            $(this).removeClass("active");
        });

    }
    initSelectedDatesHover() {
        let instance = this;
        let startInput = null;
        let endInput = null;





        if (instance.fullDates.selectedDates) {

            instance.startFill(instance.fullDates.selectedDates);
        }
        startInput = $(document).find("input[name='start']");
        endInput = $(document).find("input[name='end']");



        if (!instance.fullDates.dates[0] && !instance.fullDates.dates[1]) {

            startInput.addClass("callout alert");
            endInput.removeClass("callout alert");

        } else if (instance.fullDates.dates[0] && !instance.fullDates.dates[1]) {
            startInput.removeClass("callout alert");

            // startInput.val("Есть");
            endInput.addClass("callout alert");
        } else if (!instance.fullDates.dates[0] && instance.fullDates.dates[1]) {
            startInput.addClass("callout alert");
            endInput.removeClass("callout alert");
        } else if (instance.fullDates.dates[0] && instance.fullDates.dates[1]) {

            startInput.removeClass("callout alert");
            endInput.removeClass("callout alert");
            // startInput.val("Есть");
            // endInput.val("Есть");
        }

        if (!instance.selectedRangeDatesIsUSe) {


            $(document).on("click", ".calendar-date-disabled--hover", function(e) {



                if (instance.fullDates.dates[0] && instance.fullDates.dates[1]) {
                    startInput = $(document).find("input[name='start']");
                    endInput = $(document).find("input[name='end']");
                    endInput.addClass("callout alert");
                    endInput.val("");

                    instance.fullDates.dates[1] = null;
                    instance.fullDates.dates[0] = parseInt($(this).attr("data-key"));
                    instance.startPicker.setDate(new Date().setTime(instance.fullDates.dates[0]));

                    instance.fullDates.dates.splice(1, 1);
                    instance.fullDates.selectedDates = [];
                    instance.endFill();
                    return;


                }


                if (instance.fullDates.dates[0]) {

                    instance.fullDates.dates[1] = parseInt($(this).attr("data-key"));
                    let range = [];
                    if (parseInt(instance.fullDates.dates[0]) <= parseInt(instance.fullDates.dates[1])) {
                        range = instance.expandRange(parseInt(instance.fullDates.dates[0]), parseInt(instance.fullDates.dates[1]));
                    } else {

                        range = instance.expandRange(parseInt(instance.fullDates.dates[1]), parseInt(instance.fullDates.dates[0]));
                    }

                    instance.fullDates.selectedDates = range;
                    instance.startFill(range);
                    startInput = $(document).find("input[name='start']");
                    endInput = $(document).find("input[name='end']");
                    endInput.removeClass("callout alert");

                    instance.endPicker.setDate(new Date().setTime(instance.fullDates.dates[1]));

                } else if (instance.fullDates.dates[1]) {
                    instance.fullDates.dates[0] = parseInt($(this).attr("data-key"));
                    let range = [];
                    if (parseInt(instance.fullDates.dates[0]) <= parseInt(instance.fullDates.dates[1])) {
                        range = instance.expandRange(parseInt(instance.fullDates.dates[0]), parseInt(instance.fullDates.dates[1]));
                    } else {

                        range = instance.expandRange(parseInt(instance.fullDates.dates[1]), parseInt(instance.fullDates.dates[0]));
                    }
                    startInput = $(document).find("input[name='start']");
                    startInput.removeClass("callout alert");

                    instance.fullDates.selectedDates = range;
                    instance.startFill(range);


                    instance.startPicker.setDate(new Date().setTime(instance.fullDates.dates[0]));

                } else {
                    startInput = $(document).find("input[name='start']");
                    endInput = $(document).find("input[name='end']");

                    startInput.removeClass("callout alert");
                    startInput.val("есть");
                    endInput.addClass("callout alert");
                    instance.fullDates.dates[0] = parseInt($(this).attr("data-key"));
                    instance.startPicker.setDate(new Date().setTime(instance.fullDates.dates[0]));
                }

                //
                // if (parseInt(instance.fullDates.dates[0]) > parseInt(instance.fullDates.dates[1])) {
                //     instance.endPicker.setDate(new Date().setTime(instance.fullDates.dates[0]));
                //     instance.startPicker.setDate(new Date().setTime(instance.fullDates.dates[1]));
                // }

                instance.drowCountDays();
            });

            $(document).on("mouseenter", ".calendar-date-disabled--hover", function(e) {

                if (instance.fullDates.dates[0] && !instance.fullDates.dates[1]) {

                    let range = [];
                    instance.endFill();

                    if (parseInt(instance.fullDates.dates[0]) <= parseInt($(this).attr("data-key"))) {
                        range = instance.expandRange(parseInt(instance.fullDates.dates[0]), parseInt($(this).attr("data-key")));
                    } else {
                        range = instance.expandRange(parseInt($(this).attr("data-key")), parseInt(instance.fullDates.dates[0]));
                    }

                    instance.startFill(range);
                }


            });


        }
        instance.selectedRangeDatesIsUSe = true;
    }

    drowCountDays() {
        if (this.fullDates.dates[0] && this.fullDates.dates[1]) {
            $(document).find("#calendar-selected-count").text(this.fullDates.selectedDates.length + " ");
        } else {
            $(document).find("#calendar-selected-count").text(0 + " ");
        }

    }

    initLitePickersForCreateDates() {
        let instance = this;

        let startInput = null;
        let endInput = null;


        instance.startPicker = new Litepicker({
            element: $("[datapicker-object-calendar-start]")[0],
            lang: "ru-RU",
            format: "D.MM.YYYY",
            minDate: Date.now(),
            singleMode: true,
            autoApply: true,
            onSelect: function(date) {
                startInput = $(document).find("input[name='start']");
                endInput = $(document).find("input[name='end']");
                if (!instance.fullDates.dates[1]) {
                    instance.endFill();

                    endInput.addClass("callout alert");
                    startInput.removeClass("callout alert");
                    endInput.val("")
                    instance.fullDates.dates[0] = new Date(date).getTime();
                    instance.fullDates.dates[1] = null;
                    $("[data-key='" + instance.fullDates.dates[0] + "']").addClass("active");


                } else {
                    instance.fullDates.dates[0] = new Date(date).getTime();
                    startInput.removeClass("callout alert");
                    instance.endFill();
                    let range = [];
                    if (parseInt(instance.fullDates.dates[0]) <= parseInt(instance.fullDates.dates[1])) {
                        range = instance.expandRange(parseInt(instance.fullDates.dates[0]), parseInt(instance.fullDates.dates[1]));
                    } else {
                        range = instance.expandRange(parseInt(instance.fullDates.dates[1]), parseInt(instance.fullDates.dates[0]));
                        this
                    }


                    instance.fullDates.selectedDates = range;
                    instance.startFill(range);

                }

                instance.drowCountDays();

                if ((instance.fullDates.dates[0] && instance.fullDates.dates[1]) && (instance.fullDates.dates[0] > instance.fullDates.dates[1])) {
                    let swap = instance.fullDates.dates[0];
                    let formatter = new Intl.DateTimeFormat("ru");


                    instance.fullDates.dates[0] = instance.fullDates.dates[1];

                    instance.fullDates.dates[1] = swap;

                    this.options.startDate.dateInstance = new Date(new Date().setTime(instance.fullDates.dates[0]));

                    endInput.val(formatter.format(new Date(new Date().setTime(instance.fullDates.dates[1]))));

                }

            },
        });

        let dateStart = instance.fullDates.dates[0];

        if (dateStart) {
            instance.startPicker.setDate(new Date().setTime(dateStart));
        }

        instance.endPicker = new Litepicker({
            element: $("[datapicker-object-calendar-end]")[0],
            lang: "ru-RU",
            format: "D.MM.YYYY",
            minDate: Date.now(),
            singleMode: true,
            autoApply: true,
            onSelect: function(date) {


                instance.endFill();
                startInput = $(document).find("input[name='start']");
                endInput = $(document).find("input[name='end']");

                endInput.removeClass("callout alert");
                // startInput.removeClass("callout alert");

                instance.fullDates.dates[1] = new Date(date).getTime();
                let range = [];
                if (parseInt(instance.fullDates.dates[0]) <= parseInt(instance.fullDates.dates[1])) {
                    range = instance.expandRange(parseInt(instance.fullDates.dates[0]), parseInt(instance.fullDates.dates[1]));
                } else {
                    range = instance.expandRange(parseInt(instance.fullDates.dates[1]), parseInt(instance.fullDates.dates[0]));

                }

                instance.fullDates.selectedDates = range;
                instance.startFill(range);
                instance.drowCountDays();


                if ((instance.fullDates.dates[0] && instance.fullDates.dates[1]) && (instance.fullDates.dates[0] > instance.fullDates.dates[1])) {
                    let swap = instance.fullDates.dates[0];
                    let formatter = new Intl.DateTimeFormat("ru");


                    instance.fullDates.dates[0] = instance.fullDates.dates[1];

                    instance.fullDates.dates[1] = swap;

                    this.options.startDate.dateInstance = new Date(new Date().setTime(instance.fullDates.dates[1]));

                    startInput.val(formatter.format(new Date(new Date().setTime(instance.fullDates.dates[0]))));

                }


            },
        });


        let dateEnd = instance.fullDates.dates[1];

        if (dateEnd) {
            instance.endPicker.setDate(new Date().setTime(dateEnd));
        }


        // }
    }

    createDatesInputs() {
        let datesInputs = $("<div />", {
            class: "calendar-control-inputs",
            html: "<div class='grid-x grid-padding-x align-right'>" +
                "<div class='cell small-12 medium-shrink'><label>Начало</label><input style='cursor: pointer;' readonly datapicker-object-calendar-start name='start'></div>" +
                "<div class='cell small-12 medium-shrink'><label>Окончание</label><input style='cursor: pointer;' readonly datapicker-object-calendar-end name='end'></div>" +
                "</div>" +
                "<div class='grid-x grid-padding-x align-right align-middle text-right'>" +
                "<div class='cell medium-shrink auto'><span >Длительность: </span><span id='calendar-selected-count'>0 </span>д.</div>" +
                "<div class='cell medium-shrink shrink'><button type='button' id='calendar-apply' href='#' class='button  no-margin'>Ок</button></div>" +
                "</div>"
        });


        return datesInputs;





    }
    init(calendar = false) {
        let instance = this;
        if ($("#" + instance.idContainer).length) {
            let mounth = instance.createMonth();
            let days = instance.createDays();
            let weekDays = instance.createWeekDays();
            let datesInputs = instance.createDatesInputs();
            if (calendar) {
                instance.calendar = document.createElement("div");
                instance.calendar.classList.add("calendar");
            }
            instance.calendar.appendChild(mounth);
            instance.calendar.appendChild(weekDays);
            instance.calendar.appendChild(days);
            instance.calendar.appendChild(datesInputs[0]);

            $("#" + instance.idContainer).html(instance.calendar);
            instance.initSelectedDatesHover();
            instance.initLitePickersForCreateDates();

        }

    }
}